// Translation: Account > Profile > Specialties (Turkish)
export default Object.freeze({
	form: {
		fields: {
			img_labeling: '__Resim etiketleme',
			ml_engineering: '__Makine Öğrenimi (ML) Mühendisi',
			scientist: '__Bilim',
			text_labeling:	'__Yazı etiketleme',
			translation: '__Çeviri'
		}
	},
	title: 'Uzmanlıklar'
})
